export interface Video {
  id: string;
  title: string;
  description: string;
  category: string;
  tags: string[];
  imageUrl: string;
  rating: number;
  year: string;
  duration: string;
  quality: string;
  views: number;
  isHot: boolean;
  isNew: boolean;
  isVip: boolean;
  slug: string;
}

export const videos: Video[] = [
  {
    id: 'v001',
    title: '流浪地球3',
    description: '太阳急速老化膨胀，人类面临前所未有的生存危机。在地球开始流浪之后，新的挑战接踵而至，人类文明能否延续？宏大震撼的科幻巨制续作。',
    category: 'dianying',
    tags: ['科幻', '灾难', '冒险'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20with%20Earth%20in%20space%20dramatic%20lighting%2C%20warm%20orange%20and%20red%20tones%2C%20cinematic%20film%20texture%2C%20clean%20dark%20background%20with%20stars%2C%20professional%20movie%20promotional%20visual%20style&width=450&height=600&seq=vid-v001&orientation=portrait',
    rating: 9.2,
    year: '2026',
    duration: '148分钟',
    quality: '4K',
    views: 12860000,
    isHot: true,
    isNew: true,
    isVip: false,
    slug: 'liulang-diqiu-3',
  },
  {
    id: 'v002',
    title: '封神第二部：战火西岐',
    description: '商周大战一触即发，姜子牙率领众神迎战。姬发在战火中成长，封神榜上的名字逐渐显现，一场决定天下命运的战争拉开序幕。',
    category: 'dianying',
    tags: ['奇幻', '古装', '神话'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20mythology%20fantasy%20movie%20poster%20with%20ancient%20warriors%20and%20gods%2C%20dramatic%20golden%20and%20red%20tones%2C%20epic%20cinematography%20style%2C%20clean%20background%20with%20mist%2C%20professional%20film%20visual&width=450&height=600&seq=vid-v002&orientation=portrait',
    rating: 8.9,
    year: '2026',
    duration: '156分钟',
    quality: '4K',
    views: 9650000,
    isHot: true,
    isNew: false,
    isVip: false,
    slug: 'fengshen-zhanhuo-xiqi',
  },
  {
    id: 'v003',
    title: '繁花似锦',
    description: '以上海为背景，讲述了改革开放浪潮中几位年轻人从青涩到成熟的人生历程，展现了大时代下小人物的命运沉浮与家国情怀。',
    category: 'dianshiju',
    tags: ['都市', '年代', '励志'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20with%20Shanghai%20cityscape%2C%20warm%20vintage%20tones%2C%20nostalgic%20atmosphere%2C%20elegant%20composition%2C%20clean%20soft%20background%2C%20professional%20TV%20series%20visual&width=450&height=600&seq=vid-v003&orientation=portrait',
    rating: 8.7,
    year: '2025',
    duration: '45分钟/集',
    quality: '1080P',
    views: 8500000,
    isHot: true,
    isNew: false,
    isVip: false,
    slug: 'fanhua-sijin',
  },
  {
    id: 'v004',
    title: '长安十二时辰之凤凰劫',
    description: '天宝三年上元节，长安城暗流涌动。神秘的凤凰图案背后隐藏着一个惊天秘密，张小敬再次出手，这一次他面对的是更加可怕的敌人。',
    category: 'dianshiju',
    tags: ['古装', '悬疑', '动作'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20suspense%20drama%20poster%20with%20Tang%20dynasty%20palace%20setting%2C%20mysterious%20dark%20red%20and%20black%20tones%2C%20phoenix%20motif%2C%20dramatic%20lighting%2C%20clean%20background%2C%20professional%20film%20visual&width=450&height=600&seq=vid-v004&orientation=portrait',
    rating: 9.0,
    year: '2026',
    duration: '42分钟/集',
    quality: '4K',
    views: 11200000,
    isHot: true,
    isNew: true,
    isVip: true,
    slug: 'changan-fenghuang-jie',
  },
  {
    id: 'v005',
    title: '脱口秀大会第八季',
    description: '全新一季脱口秀大会强势回归，更多新人加入，更爆笑的段子，更犀利的观点。各路喜剧人齐聚一堂，用幽默解构生活。',
    category: 'zongyi',
    tags: ['脱口秀', '喜剧', '综艺'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Stand-up%20comedy%20show%20poster%20with%20microphone%20and%20spotlight%2C%20bright%20warm%20colors%2C%20cheerful%20atmosphere%2C%20clean%20stage%20background%2C%20professional%20variety%20show%20visual&width=450&height=600&seq=vid-v005&orientation=portrait',
    rating: 8.5,
    year: '2026',
    duration: '90分钟/期',
    quality: '1080P',
    views: 7200000,
    isHot: true,
    isNew: true,
    isVip: false,
    slug: 'tuokouxiu-dahui-8',
  },
  {
    id: 'v006',
    title: '深海',
    description: '一个沉溺于过往的女孩，在一次意外中坠入深海，遇到了神秘的海底世界和奇妙的生物。一段关于自我救赎的奇幻冒险之旅。',
    category: 'dongman',
    tags: ['奇幻', '治愈', '冒险'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%20with%20deep%20sea%20underwater%20scene%2C%20magical%20blue%20and%20purple%20ink%20wash%20style%2C%20dreamy%20atmosphere%2C%20clean%20background%2C%20artistic%20animation%20visual&width=450&height=600&seq=vid-v006&orientation=portrait',
    rating: 9.1,
    year: '2026',
    duration: '112分钟',
    quality: '4K',
    views: 6800000,
    isHot: true,
    isNew: false,
    isVip: false,
    slug: 'shenhai',
  },
  {
    id: 'v007',
    title: '狂飙：黎明之前',
    description: '扫黑除恶专项斗争持续深入，安欣在退休之前接手了最后一个案子，这个案子牵扯出了一个隐藏更深的犯罪网络。',
    category: 'dianshiju',
    tags: ['刑侦', '犯罪', '剧情'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20poster%20with%20urban%20night%20scene%2C%20dark%20blue%20and%20steel%20gray%20tones%2C%20suspenseful%20atmosphere%2C%20clean%20background%20with%20city%20lights%2C%20professional%20TV%20series%20visual&width=450&height=600&seq=vid-v007&orientation=portrait',
    rating: 9.3,
    year: '2025',
    duration: '45分钟/集',
    quality: '4K',
    views: 15300000,
    isHot: true,
    isNew: false,
    isVip: false,
    slug: 'kuangbiao-liming',
  },
  {
    id: 'v008',
    title: '速度与激情11',
    description: '多米尼克和他的家人们面临了有史以来最强大的敌人。全球各地的飙车场面令人血脉贲张，最终的决战在东京街头上演。',
    category: 'dianying',
    tags: ['动作', '犯罪', '冒险'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Hollywood%20action%20movie%20poster%20with%20fast%20cars%20and%20Tokyo%20cityscape%2C%20vibrant%20neon%20lights%2C%20dynamic%20racing%20scene%2C%20clean%20dark%20background%2C%20professional%20film%20visual&width=450&height=600&seq=vid-v008&orientation=portrait',
    rating: 8.6,
    year: '2026',
    duration: '142分钟',
    quality: '4K',
    views: 10500000,
    isHot: true,
    isNew: true,
    isVip: true,
    slug: 'sudu-yu-jiqing-11',
  },
  {
    id: 'v009',
    title: '地球脉动第四季',
    description: 'BBC经典自然纪录片新作，历时四年拍摄，跨越七大洲，用最先进的摄影技术展现地球上最壮观的自然奇观和野生动物的生存故事。',
    category: 'jilupian',
    tags: ['自然', '动物', '探索'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20with%20Earth%20from%20space%20and%20wildlife%20silhouettes%2C%20deep%20green%20and%20blue%20tones%2C%20majestic%20atmosphere%2C%20clean%20background%2C%20professional%20BBC%20style%20visual&width=450&height=600&seq=vid-v009&orientation=portrait',
    rating: 9.8,
    year: '2026',
    duration: '60分钟/集',
    quality: '4K',
    views: 4300000,
    isHot: true,
    isNew: true,
    isVip: false,
    slug: 'diqiu-maidong-4',
  },
  {
    id: 'v010',
    title: '西游记之大圣归来2',
    description: '大圣归来之后的冒险续作，孙悟空带着新伙伴踏上西行之路。面对更强大的妖魔和更艰难的考验，大圣能否再次力挽狂澜？',
    category: 'dongman',
    tags: ['神话', '动作', '冒险'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20mythology%20animated%20film%20poster%20with%20Monkey%20King%20hero%20pose%2C%20vibrant%20red%20and%20gold%20tones%2C%20epic%20action%20style%2C%20clean%20cloud%20background%2C%20professional%20animation%20visual&width=450&height=600&seq=vid-v010&orientation=portrait',
    rating: 8.8,
    year: '2026',
    duration: '125分钟',
    quality: '4K',
    views: 8900000,
    isHot: true,
    isNew: true,
    isVip: false,
    slug: 'dasheng-guilai-2',
  },
  {
    id: 'v011',
    title: '三体：黑暗森林',
    description: '面壁计划正式启动，罗辑被选为面壁者之一。在人类与三体文明的僵持中，黑暗森林法则逐渐浮出水面，整个宇宙的秘密即将揭晓。',
    category: 'dianshiju',
    tags: ['科幻', '悬疑', '剧情'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Sci-fi%20cosmic%20drama%20poster%20with%20universe%20and%20stars%2C%20dark%20mysterious%20atmosphere%2C%20deep%20space%20background%2C%20minimalist%20design%20with%20light%20beams%2C%20professional%20TV%20series%20visual&width=450&height=600&seq=vid-v011&orientation=portrait',
    rating: 9.4,
    year: '2025',
    duration: '50分钟/集',
    quality: '4K',
    views: 18500000,
    isHot: true,
    isNew: false,
    isVip: true,
    slug: 'santi-heian-senlin',
  },
  {
    id: 'v012',
    title: '小猪佩奇大电影：环球冒险',
    description: '佩奇和她的家人朋友们开启了一次环球旅行，从伦敦到巴黎，从纽约到东京，一路上的奇遇让孩子们欢笑不断，寓教于乐的精彩故事。',
    category: 'shaoer',
    tags: ['动画', '冒险', '教育'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Children%20animated%20film%20poster%20with%20cute%20pig%20family%20traveling%20around%20world%2C%20bright%20colorful%20cartoon%20style%2C%20cheerful%20atmosphere%2C%20clean%20background%2C%20professional%20kids%20animation%20visual&width=450&height=600&seq=vid-v012&orientation=portrait',
    rating: 8.2,
    year: '2026',
    duration: '78分钟',
    quality: '1080P',
    views: 3200000,
    isHot: false,
    isNew: true,
    isVip: false,
    slug: 'xiaozhu-peiqi-huanqiu',
  },
  {
    id: 'v013',
    title: '中国奇谭第二季',
    description: '延续第一季的精美画风和传统文化内核，第二季带来全新的八个志怪故事。每个故事都融合了中国传统美学与现代动画技术。',
    category: 'dongman',
    tags: ['奇幻', '传统文化', '单元剧'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20traditional%20ink%20wash%20animation%20poster%20with%20mythical%20creatures%2C%20elegant%20brush%20painting%20style%2C%20soft%20warm%20tones%2C%20clean%20rice%20paper%20background%2C%20artistic%20animation%20visual&width=450&height=600&seq=vid-v013&orientation=portrait',
    rating: 9.0,
    year: '2026',
    duration: '22分钟/集',
    quality: '1080P',
    views: 5600000,
    isHot: false,
    isNew: true,
    isVip: false,
    slug: 'zhongguo-qitan-2',
  },
  {
    id: 'v014',
    title: '王牌对王牌第十季',
    description: '经典综艺IP十周年特别企划，超强嘉宾阵容齐聚。经典游戏环节回归加全新玩法，每一期都让你笑到停不下来。',
    category: 'zongyi',
    tags: ['游戏', '喜剧', '综艺'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Variety%20game%20show%20poster%20with%20colorful%20stage%20lights%20and%20celebrities%2C%20bright%20cheerful%20atmosphere%2C%20clean%20studio%20background%2C%20professional%20entertainment%20visual&width=450&height=600&seq=vid-v014&orientation=portrait',
    rating: 8.3,
    year: '2026',
    duration: '100分钟/期',
    quality: '1080P',
    views: 6100000,
    isHot: false,
    isNew: true,
    isVip: false,
    slug: 'wangpai-diwangpai-10',
  },
  {
    id: 'v015',
    title: '舌尖上的中国第五季',
    description: '时隔多年，舌尖上的中国回归。这一次摄制组走遍中国34个省级行政区，探寻最地道的地方美食和背后的文化故事。',
    category: 'jilupian',
    tags: ['美食', '文化', '旅行'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%20with%20steaming%20hot%20delicious%20dishes%2C%20warm%20rich%20colors%2C%20appetizing%20atmosphere%2C%20clean%20dark%20wood%20background%2C%20professional%20culinary%20visual&width=450&height=600&seq=vid-v015&orientation=portrait',
    rating: 9.6,
    year: '2026',
    duration: '50分钟/集',
    quality: '4K',
    views: 7800000,
    isHot: true,
    isNew: true,
    isVip: false,
    slug: 'shejianshang-zhongguo-5',
  },
  {
    id: 'v016',
    title: '熊出没之重返地球',
    description: '光头强和熊大熊二意外登上了一艘外星飞船，开启了一段惊险刺激的太空冒险之旅。面对外星文明的挑战，他们能否保护地球家园？',
    category: 'shaoer',
    tags: ['冒险', '喜剧', '科幻'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Children%20animated%20adventure%20poster%20with%20bears%20and%20space%20theme%2C%20colorful%20fun%20cartoon%20style%2C%20bright%20atmosphere%2C%20clean%20star%20background%2C%20professional%20kids%20animation%20visual&width=450&height=600&seq=vid-v016&orientation=portrait',
    rating: 7.9,
    year: '2025',
    duration: '95分钟',
    quality: '1080P',
    views: 4100000,
    isHot: false,
    isNew: false,
    isVip: false,
    slug: 'xiong-chumo-chongfan',
  },
];